import { render } from "./ModioToast.vue?vue&type=template&id=c42028cc"
import script from "./ModioToast.vue?vue&type=script&lang=js"
export * from "./ModioToast.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__